<template>
  <div>
    <div class="lk-table">
      <div v-if="$slots.filter" class="lk-table__filter">
        <slot name="filter" />
      </div>
      <table class="lk-table__table">
        <thead>
          <tr class="lk-table__head">
            <th v-for="col in config" :key="col.key" :style="getColWidth(col)" :class="['lk-table__head-item', col.align || 'left']">
              <slot :name="'head.' + col.key" :col="col">
                {{ col.label || col.key }}
              </slot>
            </th>
          </tr>
        </thead>

        <tbody v-if="!loading && data && data.length">
          <tr v-for="(row, ri) in data" :key="row[rowKey] || ri" :class="['lk-table__row', rowClass(row, ri)]">
            <td v-for="(col, ci) in config" :key="col.key" :style="getColWidth(col)" :class="['lk-table__row-item', ...col.classList]">
              <template v-if="col.type === cellType.TEMPLATE">
                <slot :name="col.templateName" :value="row[col.key]">
                  {{ row[col.key] }}
                </slot>
              </template>
              <template v-else-if="col.type === cellType.DATE">
                <span>{{ formatDate(row[col.key]) }}</span>
              </template>
              <template v-else-if="col.type === cellType.STRING">
                <span :class="[clampClass(col)]" :title="col.tooltip ? col.tooltip(row) : null">
                  {{ row[col.key] }}
                </span>
              </template>
              <template v-else>{{ row[col.key] }}</template>
            </td>
          </tr>
        </tbody>

        <tbody v-else-if="loading">
          <tr v-for="i in skeletonRows" :key="'s' + i">
            <td v-for="col in config" :key="col.key">
              <div class="skeleton"></div>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td :colspan="config.length" class="empty">
              <slot name="empty"></slot>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <lk-pagination
      v-animation:bottom.delay
      v-if="pagination"
      :pagination="pagination"
      :name-current-page="'currentPage'"
      class="_lk"
    />
  </div>
</template>

<script>
import pagination from '@components/ui-components/pagination/pagination.vue'
import { formatDate } from '@modules/shared/utils/datetime'
import { LK_TABLE_CELL_TYPE } from '@components/lk/lk-table/data/lk.table.data'

export default {
  name: 'lk-table',
  components: {
    'lk-pagination': pagination,
  },
  props: {
    // [{ key, label, width, minWidth, clamp:2 }]
    config: { type: Array, default: [] },
    data: { type: Array, default: [] },
    rowKey: { type: String, default: 'id' },
    loading: { type: Boolean, default: false },
    skeletonRows: { type: Number, default: 5 },
    pagination: { type: Object, default: {} },
  },
  data() {
    return {
      cellType: LK_TABLE_CELL_TYPE,
    }
  },
  methods: {
    formatDate,
    getColWidth(col) {
      const s = {}
      if (col.width) s.width = col.width
      if (col.minWidth) s.minWidth = col.minWidth
      return s
    },
    clampClass(col) {
      return col && col.clamp ? `clamp-${col.clamp}` : ''
    },
    rowClass(row, ri) {
      return typeof this.$scopedSlots.rowClass === 'function' ? this.$scopedSlots.rowClass({ row, ri }) : null
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.lk-table
  padding: 32px
  background-color: #FFFFFF
  border-radius: 6px
  box-shadow: 0 4px 25px 0 rgba(30, 37, 59, 0.03)

  &__filter
    margin-bottom: 42px

  .lk-table__wrapper
    width: 100%
    overflow-x: auto

  &__table
    width: 100%
    border-collapse: collapse

  &__head, &__row
    display: flex
    gap: 10px

  &__head-item
    color: $light-gray
    line-height: 1.5
    text-align: left

  &__row
    border-bottom: 1px solid #F5F5FA
    padding-block: 32px
    vertical-align: middle
    color: $dark-shades-black

  .left
    text-align: left

  .center
    text-align: center

  .right
    text-align: right

  .is-bold
    font-weight: 600

  .empty
    text-align: center
    color: #9aa3af
    padding: 28px

  [class^="clamp-"], [class*=" clamp-"]
    white-space: pre-line
    display: -webkit-box
    -webkit-box-orient: vertical
    overflow: hidden

  .clamp-1
    -webkit-line-clamp: 1

  .clamp-2
    -webkit-line-clamp: 2

  .clamp-3
    -webkit-line-clamp: 3

  .skeleton
    height: 14px
    background: linear-gradient(90deg,#f3f4f6 25%,#e5e7eb 37%,#f3f4f6 63%)
    background-size: 400% 100%
    animation: shimmer 1.2s infinite
    border-radius: 6px

  @keyframes shimmer
    0%
      background-position: 200% 0
    100%
      background-position: -200% 0
</style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-table/lk-table.vue